import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './part.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PartDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const partEntity = useAppSelector(state => state.part.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="partDetailsHeading">
          <Translate contentKey="fleetSenseApp.part.detail.title">Part</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{partEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.part.name">Name</Translate>
            </span>
          </dt>
          <dd>{partEntity.name}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="fleetSenseApp.part.code">Code</Translate>
            </span>
          </dt>
          <dd>{partEntity.code}</dd>
          <dt>
            <span id="cycleKm">
              <Translate contentKey="fleetSenseApp.part.cycleKm">Cycle Km</Translate>
            </span>
          </dt>
          <dd>{partEntity.cycleKm}</dd>
          <dt>
            <span id="cycleDate">
              <Translate contentKey="fleetSenseApp.part.cycleDate">Cycle Date</Translate>
            </span>
          </dt>
          <dd>{partEntity.cycleDate}</dd>
          <dt>
            <span id="cycleHour">
              <Translate contentKey="fleetSenseApp.part.cycleHour">Cycle Hour</Translate>
            </span>
          </dt>
          <dd>{partEntity.cycleHour}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="fleetSenseApp.part.image">Image</Translate>
            </span>
          </dt>
          <dd>
            {partEntity.image ? (
              <div>
                {partEntity.imageContentType ? (
                  <a onClick={openFile(partEntity.imageContentType, partEntity.image)}>
                    <img src={`data:${partEntity.imageContentType};base64,${partEntity.image}`} style={{ maxHeight: '30px' }} />
                  </a>
                ) : null}
                <span>
                  {partEntity.imageContentType}, {byteSize(partEntity.image)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="objectKey">
              <Translate contentKey="fleetSenseApp.part.objectKey">Object Key</Translate>
            </span>
          </dt>
          <dd>{partEntity.objectKey}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.part.description">Description</Translate>
            </span>
          </dt>
          <dd>{partEntity.description}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.part.company">Company</Translate>
          </dt>
          <dd>{partEntity.company ? partEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/part" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/part/${partEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PartDetail;
